import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'pf-gyik',
    templateUrl: './gyik.component.html',
    styleUrls: ['./gyik.component.scss'],
    standalone: true,
    imports: [RouterLink]
})
export class GyikComponent { }
